export default "__VITE_ASSET__Csww4pAP__"